// src/apps/frontend/routes/index.tsx
import {Routes, Route, Navigate} from 'react-router-dom';
import MainLayout from '../layouts/MainLayout';
import Dashboard from "~/apps/base/pages/Dashboard.tsx";

export const BaseRoutes = () => {
    return (
        <MainLayout>
            <Routes>
                <Route path='/' element={<Dashboard />}/>
                <Route path="/*" element={<Navigate to="/errors/404" replace />} />
            </Routes>
        </MainLayout>
    );
}
